import { createContext } from 'react';

export const SelectsContext = createContext();
